<template>
  <header class="site-header">
    <div class="header-bg" />
    <div class="header-inner">
      <router-link to="/" class="logo">
        <div class="logo-icon">
          <svg viewBox="0 0 40 40" fill="none">
            <rect width="40" height="40" rx="10" fill="url(#logo-grad)" />
            <path d="M12 28V14l8 5-8 5v-5l4-2.5" stroke="#fff" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" fill="none" />
            <path d="M20 22v7l8-5-8-5v5l-4 2.5" stroke="#fff" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" fill="none" opacity="0.7" />
            <defs>
              <linearGradient id="logo-grad" x1="0" y1="0" x2="40" y2="40">
                <stop offset="0%" stop-color="#4e7cff" />
                <stop offset="100%" stop-color="#6b3cf0" />
              </linearGradient>
            </defs>
          </svg>
        </div>
        <span class="logo-text">IEasyTool<span class="logo-dot">·</span><span class="logo-sub">{{ $t('layout.brand.slogan') }}</span></span>
      </router-link>

      <div class="header-center">
        <SearchBar @select="goTool" />
      </div>

      <nav class="header-right">
        <router-link to="/" class="nav-link">
          <i class="el-icon-s-home" style="margin-right:4px;" />{{ $t('layout.nav.home') }}
        </router-link>
        <router-link to="/favorites" class="nav-link">
          <i class="el-icon-star-off" style="margin-right:4px;" />{{ $t('layout.nav.favorites') }}
        </router-link>
        <el-dropdown trigger="click" @command="goCategory">
          <span class="nav-link el-dropdown-link">
            <i class="el-icon-menu" style="margin-right:4px;" />{{ $t('layout.nav.category') }}<i class="el-icon-arrow-down el-icon--right" />
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-for="cat in categories" :key="cat.id" :command="cat.slug">
              {{ cat.name }}
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-dropdown trigger="click" @command="switchLang" class="lang-switch">
          <span class="nav-link el-dropdown-link">
            <i class="el-icon-s-flag" style="margin-right:4px;" />{{ currentLangLabel }}<i class="el-icon-arrow-down el-icon--right" />
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="zh" :disabled="lang==='zh'">中文</el-dropdown-item>
            <el-dropdown-item command="en" :disabled="lang==='en'">English</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </nav>
    </div>
  </header>
</template>

<script>
import SearchBar from '@/components/SearchBar'
import { getCategoryList } from '@/api/site'
import { getLanguage, setLanguage } from '@/i18n'

export default {
  components: { SearchBar },
  created() { this.loadCategories() },
  data() {
    return { categories: [], lang: getLanguage() }
  },
  computed: {
    currentLangLabel() { return this.lang === 'en' ? 'English' : '中文' }
  },
  methods: {
    loadCategories() {
      getCategoryList().then(res => { this.categories = res.data || [] })
    },
    switchLang(lang) {
      if (lang === this.lang) return
      setLanguage(lang)
      // 首期策略：整页刷新，确保动态内容(工具名/描述等)按新语言重新拉取
      window.location.reload()
    },
    goCategory(slug) {
      this.$router.push(`/category/${slug}`)
    },
    goTool(slug) {
      this.$router.push(`/tool/${slug}`)
    }
  }
}
</script>

<style scoped>
.site-header {
  height: 64px;
  position: sticky;
  top: 0;
  z-index: 100;
}
.header-bg {
  position: absolute;
  inset: 0;
  background: rgba(255,255,255,0.82);
  backdrop-filter: blur(16px) saturate(180%);
  -webkit-backdrop-filter: blur(16px) saturate(180%);
  border-bottom: 1px solid rgba(0,0,0,0.06);
}
.header-inner {
  max-width: 1200px;
  margin: 0 auto;
  height: 100%;
  display: flex;
  align-items: center;
  padding: 0 20px;
  position: relative;
  z-index: 1;
}

/* ---- Logo ---- */
.logo {
  display: flex;
  align-items: center;
  margin-right: 32px;
  flex-shrink: 0;
}
.logo-icon {
  width: 40px;
  height: 40px;
  margin-right: 10px;
}
.logo-icon svg { width: 40px; height: 40px; display: block; }
.logo-text {
  font-size: 20px;
  font-weight: 800;
  color: #1a1f36;
  letter-spacing: 2px;
  display: flex;
  align-items: baseline;
}
.logo-dot {
  color: #4e7cff;
  margin: 0 1px;
  font-size: 24px;
}
.logo-sub {
  font-size: 12px;
  font-weight: 400;
  color: #8892a6;
  letter-spacing: 1px;
  margin-left: 2px;
}

.header-center {
  flex: 1;
  display: flex;
  justify-content: center;
}
.header-right {
  display: flex;
  align-items: center;
  margin-left: 24px;
  flex-shrink: 0;
}
.nav-link {
  color: #4a5568;
  font-size: 14px;
  margin-left: 24px;
  cursor: pointer;
  transition: color 0.2s;
  display: flex;
  align-items: center;
  font-weight: 500;
}
.nav-link:hover { color: #4e7cff; }
</style>
